<!--
 * @Author: qnghe
 * @Date: 2025-01-20 14:15:37
 * @LastEditTime: 2025-05-13 14:55:41
 * @Description: 年计划 动态分类
-->
<template>
  <div class="year-next atb-flex atb-flex-column">
    <header class="header atb-flex atb-flex-items-center">
      <div class='year-title'>
        <h2 class="title-text">{{this.summaryData.resWkName ? this.summaryData.title + ' / ' + this.summaryData.resWkName: ''}}</h2>
        <span class="save-status">{{saveStatus}}</span>
      </div>
    </header>
    <div class='container search-and-content atb-content-bg atb-flex atb-flex-column' id="year-wrap">
      <div class='search'>
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native="getList(1)" @submit.native.prevent>
          <el-form-item class="flex-form-item" label="类别">
             <el-autocomplete v-model="searchParam.WorkItemCategory" :fetch-suggestions="queryCategory" placeholder="类别" clearable></el-autocomplete>
          </el-form-item>
          <el-form-item class="flex-form-item" label="分类">
            <el-select v-model="searchParam.WorkClassify" placeholder="分类" clearable>
              <el-option v-for="item in classifyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="flex-form-item" label="状态">
            <el-select v-model="searchParam.Status" placeholder="状态" clearable>
              <el-option v-for="item in completeList" :key="item.id" :label="item.itemDesc" :value="item.itemValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="flex-form-item" label="关键字">
            <el-input v-model="searchParam.KeyWord" placeholder="工作项目" clearable></el-input>
          </el-form-item>
        </el-form>
        <el-form :inline="true" class="atb-input function">
          <el-form-item>
            <el-radio-group v-model="model" @change="changeModel">
              <el-radio label="1">完整模式</el-radio>
              <el-radio label="2">计划模式</el-radio>
              <el-radio label="3">半年总结</el-radio>
              <el-radio label="4">全年总结</el-radio>
              <el-radio label="5">汇报模式</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(1)">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="deleteDetails">删除</el-button>
          </el-form-item>
          <el-form-item>
            <el-dropdown trigger="click" placement="bottom-start" @command="handleCommand">
              <el-button type="import" plain class="menu-button">
                批量操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown" >
                <el-dropdown-item command="a">开始日期</el-dropdown-item>
                <el-dropdown-item command="b">最终完成日期</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
        </el-form>
      </div>
      <div class='table-content atb-flex atb-flex-column'>
        <div v-show="showCollapse" class="collapse" @click="collapse($refs.yearTable, tableColumn)">
          <i :class="[isCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
        </div>
        <vxe-table
          class='atb-table header-table edit-table border-table disable-ellipsis'
          border='full'
          height='100%'
          auto-resize
          resizable
          row-key="id"
          :data="tableData"
          ref="yearTable"
          :row-class-name="setRowClass"
          :edit-config="{trigger: 'click', mode: 'row', activeMethod: editActived}"
          @edit-closed="editClosed"
          @edit-actived="activeRow"
          @cell-click="expandRowContent"
          :edit-rules="validRules"
          :spanMethod="mergeMethod"
          :tree-config="{indent: 0, iconOpen: 'icon-arrow-up-bold', iconClose: 'icon-arrow-down-bold-copy', expandAll: true, }"
          :checkbox-config="{visibleMethod: checkboxVisible, checkField: 'isChecked'}"
        >
          <!-- :merge-cells="mergeCells" -->
          <!-- :spanMethod="mergeMethod" -->
          <vxe-table-column field="tree" width='0' max-width="0" tree-node>
            <template #default="{row, rowIndex}">
              <div v-if="row.isClassifyRow" class='row-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                <div class="classify-wrap">
                  <span class="classify-name" @click.stop="expandThisRow(row)">
                    <span v-if="row.children.length === 0" class="empty-children-expand-icon">
                      <i :class="[row.emptyChildrenExpand ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy']" @click.stop="emptyChildrenExpandHandler(row)"></i>
                    </span>
                    <span>{{ row.classifyName }}</span>
                  </span>
                </div>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column type='checkbox' width='40' align='center'></vxe-table-column>
          <vxe-table-column field="workItemNo" width="50" title="NO." align="center">
            <template #default="scope">
              <span>{{seqMethod(scope)}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemCategory" min-width="60" title="类别" :edit-render="{name: 'ElAutocomplete', autofocus: '.el-textarea__inner'}">
             <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.workItemCategory}}</div>
            </template>
            <template #edit="{ row }">
             <el-autocomplete v-model="row.workItemCategory" type="textarea" :autosize="{ maxRows: 8 }" :fetch-suggestions="queryCategory" >
               <template slot-scope="{ item }">
                <el-tooltip
                  class="item"
                  effect='dark'
                  :content="item.value"
                  placement="right-start"
                >
                 <div class="query-item-text atb-ellipsis">{{ item.value }}</div>
                </el-tooltip>
               </template>
             </el-autocomplete>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemContent" title="工作项目" min-width="100" :width="model == 5 ? null : 150" :edit-render="{ autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.workItemContent" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
            <template #default="scope">
              <div :class="[scope.row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{scope.row.workItemContent}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="fullTarget" min-width="100" :width="model == 4 ? null : 250" title="全年目标" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.fullTarget}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.fullTarget" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="resWkName" width="80" title="责任人" :edit-render="{autofocus: '.el-textarea__inner', enabled: false}">
            <template #edit="{ row }"><el-input type='textarea' autosize v-model="row.resWkName"></el-input></template>
          </vxe-table-column>
          <vxe-table-column field="weight" width="80" title="权重(%)" :edit-render="{autofocus: '.el-input__inner'}">
            <template #edit="{ row }">
              <el-autocomplete v-model.number="row.weight" :fetch-suggestions="querySearchWeight" :min="1" @change="validateWeight(row)" oninput="value=value.replace(/[^\.\d]/g,'')"></el-autocomplete>
            </template>
            <template #default="{ row }">
              <span>{{row.weight}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="startDate" title="开始日期" width="120" :edit-render="{autofocus: '.el-input__inner'}">
            <template #edit="{ row }">
              <el-date-picker v-model="row.startDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{ formatDate(row.startDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
          <vxe-table-column field="finishDate" title="最终完成日期" width="120" :edit-render="{autofocus: '.el-input__inner'}">
            <template #edit="{ row }">
              <el-date-picker v-model="row.finishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
          <vxe-table-column field="firstHalfTarget" min-width="120" :width="model == 5 ? null : 250" title="上半年目标" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.firstHalfTarget}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.firstHalfTarget" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="firstHalfSummary" min-width="120" :width="model == 5 ? null : 250" title="上半年总结" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.firstHalfSummary}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.firstHalfSummary" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="finishFullTarget" min-width="100" :width="model == 5 ? null : 250" title="全年目标" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.finishFullTarget}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.finishFullTarget" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="fullSummary" min-width="100" :width="model == 5 ? null : 250" title="全年总结" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.fullSummary}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.fullSummary" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remark" width="100" title="备注" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.remark}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.remark" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="提交状态" width="150" fixed="right">
            <template #default="{ row }">
              <el-tag
                v-if='row.status === 0'
                type="complete"
                effect="dark">
               {{getStatusName(row.status)}}
              </el-tag>
              <el-tag
                v-if='row.status === 10'
                type="complete"
                effect="dark">
               {{getStatusName(row.status)}}
              </el-tag>
              <el-tag
                v-if='row.status === 20'
                type="complete"
                effect="dark">
                  {{getStatusName(row.status)}}
                </el-tag>
              <el-tag
                v-if='row.status === 30'
                type="close"
                effect="dark">
                  {{getStatusName(row.status)}}
                </el-tag>
                <el-tag
                v-if='row.status === 35'
                type="complete"
                effect="dark">
                  {{getStatusName(row.status)}}
                </el-tag>
              <el-tag
                v-if='row.status === 40'
                type="complete"
                effect="dark">
                  {{getStatusName(row.status)}}
                </el-tag>
              <el-tag 
                v-if='row.status === 50'
                type="close"
                effect="dark">
                 {{getStatusName(row.status)}}
                </el-tag>
                <el-tag
                v-if='row.status === 55'
                type="complete"
                effect="dark">
                 {{getStatusName(row.status)}}
                </el-tag>
              <el-tag
                v-if='row.status === 60'
                type="complete"
                effect="dark">
                  {{getStatusName(row.status)}}
                </el-tag>
              <el-tag 
                v-if='row.status === 70'
                type="close"
                effect="dark">
                  {{getStatusName(row.status)}}
                </el-tag>
                <el-popover
                  v-if="row.status === 30 || row.status === 50 || row.status === 70" 
                  placement="top"
                  width="300"
                  trigger="hover"
                  popper-class="reason"
                  :visible-arrow='false'>
                    <div>
                      {{row.approveReason || '无'}}
                    </div>
                      <span slot="reference" class='program-tip reason'>
                      <i class='icon-hint'></i>
                    </span>
                  </el-popover>
            </template>
          </vxe-table-column>
          <vxe-table-column field="operation" title="操作" width="180" fixed="right" class-name='operation'>
            <template #default="{row, rowIndex, $rowIndex}">
              <div>
                <el-tooltip class="item" effect="dark" content="保存" placement="bottom" :popper-options="{removeOnDestroy: true}">
                  <i v-throttle class="icon-baocun" @click.stop="save(row)"></i>
                </el-tooltip>
                <el-tooltip class='item' effect='dark' content='删除' placement="bottom" :popper-options="{removeOnDestroy: true}">
                  <i v-throttle class='icon-close delete' @click.stop='deleteData(row, 1)'></i>
                </el-tooltip>
                <el-tooltip class='item' effect='dark' content='切换分类' placement="bottom" :popper-options="{removeOnDestroy: true}">
                  <i v-if="row.id" class='icon-move' @click.stop='moveClassify(row, $rowIndex)'></i>
                </el-tooltip>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
    <context-menu :data="tableColumn" :selector="`.year-next .vxe-header--row`" @columnHideToggle="columnHideToggle"></context-menu>
    <el-dialog title="转移工作分类" :visible.sync="showHandle" width="500px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <el-radio-group v-model="classify">
          <el-radio-button :key="item.label + item.value" v-for="item in classifyList" :label="item.value">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmClassify">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showHandle = false">取消</el-button>
      </span>
    </el-dialog>
    
    <common-dialog ref="addSyncDialog" :title="dialogContent.title" :width="dialogContent.width" showClose :appendBody="true">
      <template slot="content">
        <component
          v-bind:is="dialogContent.componentName"
          :command="dialogContent.command"
          :completeList="completeList"
          :selectData="selecterData"
          :editData="editData"
          :classifyConfigs="classifyConfigs"
          :from="2"
          @submitSuccess="copyLast()"
        ></component>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import qs from 'qs'
import XEUtils from 'xe-utils'
import _ from 'lodash';
import routeMixin from '@/mixins/route.mixin'

export default {
  name: 'YearPlanDetailNext',
  mixins: [routeMixin],
  components: {
    batchEdit: () => import('@/pages/personal/year-plan/batchEdit.vue'),
  },
  data() {
    const workItemContent = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 0 || row.status === 30)) {
        return new Error('工作项目不能为空')
      }
    }
    const fullTarget = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 0 || row.status === 30)) {
        return new Error('全年目标不能为空')
      }
    }
    const weight = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 0 || row.status === 30)) {
        return new Error('权重不能为空')
      }
    }
    const startDate = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 0 || row.status === 30)) {
        return new Error('开始日期不能为空')
      }
      else {
        if (row.finishDate && (row.status === 0 || row.status === 30)) {
          if (XEUtils.timestamp(cellValue) > XEUtils.timestamp(row.finishDate)) {
            return new Error('开始日期不能大于最终完成日期')
          }
        }
      }
    }
    const finishDate = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 0 || row.status === 30)) {
        return new Error('最终完成日期不能为空')
      } else {
        if (row.startDate && (row.status === 0 || row.status === 30)) {
          if (XEUtils.timestamp(cellValue) < XEUtils.timestamp(row.startDate)) {
            return new Error('最终完成日期不能小于开始日期')
          }
        }
      }
    }
    const firstHalfTarget = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 0 || row.status === 30 || row.status === 20 || row.status === 50)) {
        return new Error('上半年目标不能为空')
      }
    }
    const finishFullTarget = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 0 || row.status === 30)) {
        return new Error('全年目标不能为空')
      }
    }
    const firstHalfSummary = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 20 || row.status === 50)) {
        return new Error('上半年总结不能为空')
      }
    }
    const fullSummary = ({ cellValue, row }) => {
      if (!cellValue && (row.status === 40 || row.status === 70)) {
        return new Error('全年总结不能为空')
      }
    }
    return {
      fromPage: '',
      workId: '',
      status: null,
      msgId: null,
      childIds: null,
      model: '1',
      saveStatus: '',
      newRow: { // 新增行，默认数据
        workId: "",
        workClassify: 0,
        workItemNo: "",
        workItemCategory: "",
        workItemContent: "",
        resWkNo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).wkNo : "",
        resWkName: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).wkName : "",
        fullTarget: "",
        weight: 1,
        startDate: "",
        finishDate: "",
        firstHalfTarget: "",
        firstHalfSummary: "",
        finishFullTarget: "",
        fullSummary: "",
        completeStatus: 0,
        reason: "",
        schedule: "",
        status: 0,
        remark: "",
        parentId: null,
        expandRowContentFlag: false,
        children: null,
        isChecked: false,
        type: -1,
      },
      classifyConfigs: [],
      tableData: [],
      mergeCells: [],
      tableColumn: [],

      categoryList: [],

      editData: {},
      summaryData: {},
      searchParam: {
        WorkItemCategory: null,
        WorkClassify: null,
        KeyWord: null,
        CompleteStatus: null
      },
      
      expandRowContentAllFlag: false,

      downloadUrl: process.env.VUE_APP_PUBLICPATH + "files/年计划导入模版.xlsx",

      isCollapse: false,
      showCollapse: false,

      enabled: true,

      pending:false,
      
      dialogContent: {},

      showHandle: false,
      classify: '',

      tipMsg: '',
      validRules: {
        workItemContent: [
          { required: true, validator: workItemContent, message: '工作项目不能为空' }
        ],
        fullTarget: [
          { required: true, validator: fullTarget, message: '全年目标不能为空' }
        ],
        weight: [
          { required: true, validator: weight, message: '权重不能为空' }
        ],
        startDate: [
          { required: true, validator: startDate, message: '开始时间不能为空' }
        ],
        finishDate: [
          { required: true, validator: finishDate, message: '最终完成时间不能为空' }
        ],
        firstHalfTarget: [
          { required: true, validator: firstHalfTarget, message: '上半年目标不能为空' }
        ],
        finishFullTarget: [
          { required: true, validator: finishFullTarget, message: '全年目标不能为空' }
        ],
        firstHalfSummary: [
          { required: true, validator: firstHalfSummary, message: '上半年总结不能为空' }
        ],
        fullSummary: [
          { required: true, validator: fullSummary, message: '全年总结不能为空' }
        ],
        resWkName: [
          { required: true }
        ]
      },

      showApprove: false,
      showCompleteApprove: false,
      rejectReason: '',

      editRowOriginData: null,
    }
  },
  computed: {
    tableColumnLength() {
      return this.tableColumn.filter(val => val.visible !== false).length;
    }
  },
  watch: {
    'row.fullTarget': {
      handler(val) {
        this.$set(this.row, 'finishFullTarget', val);
      }
    },
  },
  methods: {
    deleteDetails() {
      this.selecterData = this.$refs.yearTable.getCheckboxRecords().filter(val => val.workId !== undefined);
      if (this.selecterData.length == 0) {
        this.$message.error('请先选择数据');
        return false;
      }
      this.$confirm('确定要删除吗', '删除', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        closeOnClickModal: false,
        closeOnPressEscape: false,
      }).then(() => {
        const sel = this.selecterData.map(v => v.id);
        this.$ajax.post(this.$api.workManage.year.delete, sel).then(() => {
          this.$message.success('删除成功');
          this.getList();
        })
      })
    },
    flatToTree(flatData) {
      const map = new Map();
      const tree = [];
      flatData.forEach(item => {
        map.set(item.id, { ...item, children: [] });
      });
      flatData.forEach(item => {
        const parent = map.get(item.parentId);
        if (parent) {
          parent.children.push(map.get(item.id));
        } else {
          tree.push(map.get(item.id));
        }
      });
      return tree;
    },
    treeToFlat(treeData) {
      const flatData = [];
      function traverse(node) {
        flatData.push({ ...node, children: undefined });
        if (node.children) {
          node.children.forEach(child => traverse(child));
        }
      }
      treeData.forEach(root => traverse(root));
      return flatData;
    },
    getAllChildrenRow() {
      const data = [];
      this.tableData.forEach(row => {
        const children = row.children || [];
        data.push(...children)
      })
      return data;
    },
    seqMethod({row, seq}) {
      let seqNumber = 0;
      let treeSeq = seq && typeof seq === 'string' ? seq.split('.') : (row.seq || '').split('.');
      seqNumber = treeSeq[1];
      return seqNumber || row.workItemNo;
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format)
    },
    async getWorkItemStatus() {
      await this.$ajax.get(this.$api.common.getDict, {ItemType: 'YearWorkItemStatus'}).then((res) => {
        if (res.code === 0) {
          this.completeList = res.data && res.data.rows || [];
        }
      });
    },
    getStatusName(val) {
      const obj = this.completeList.find(t => t.itemValue == val);
      return obj ? obj.itemDesc : '';
    },
    getCategory() {
      this.$ajax.get(this.$api.Identity.Categord.categoryByNo, {userId: sessionStorage.getItem("LOGIN_NAME")}).then(res => {
        const item = res.data || [];
        // this.filterCategory 全局方法
        this.categoryList = this.filterCategory(item.filter(t => t.status === 1));
      });
    },
    queryCategory(queryString, cb) {
      let categoryList = this.categoryList;
      // 调用 callback 返回建议列表的数据
      var results = queryString ? categoryList.filter(this.createFilter(queryString)) : categoryList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (categoryList) => {
        return (categoryList.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1);
      };
    },
    getList(isSearch) {
      // 保存当前状态
      const expandRecords = this.$refs.yearTable ? this.$refs.yearTable.getTreeExpandRecords() : [];
      const tableScroll = this.$refs.yearTable ? this.$refs.yearTable.getScroll() : {};

      let param = Object.assign({WorkId: this.workId,  WorkItemIds: this.childIds}, this.searchParam, this.page)
      this.$ajax.get(this.$api.workManage.year.list + '?' + qs.stringify(param, { indices: false })).then((res) => {

        if (res.data) {
          this.classifyConfigs = res.data.classifys;
          const classifyMap = {};
          const classifyRows = [];
          this.classifyList = [];

          const rows = res.data.details || [];

          this.classifyConfigs.forEach(classifyItem => {
            classifyMap[classifyItem.workClassify] = classifyItem;
            const classifyRow = {
              ...classifyItem,
              parentId: null,
              isClassifyRow: true,
              isChecked: false,
              children: [],
              emptyChildrenExpand: true,
            };
            this.classifyList.push({
              label: classifyItem.classifyName,
              value: classifyItem.workClassify,
            });
            const childs = rows.filter(row => row.workClassify === classifyItem.workClassify);
            childs.forEach(child => {
              child.expandRowContentFlag = false;
              child.isChecked = false;
              child.parentId = classifyItem.id;
              child.type = classifyItem.type;
            })
            classifyRow.children = childs || [];
            classifyRows.push(classifyRow);
          });
          
          this.tableData = classifyRows;
          this.summaryData = res.data.plan;
          this.status = this.summaryData.status;
          // this.setMerge();
        
          if (res.data.details.length > 0) {
            // this.setMerge();
            setTimeout(() => {
              this.setPosition();
            }, 50);
          }

          // 恢复状态
          this.$nextTick(() => {
            if (isSearch) {
              this.expandAll();
              return;
            }
            const ids = expandRecords.map(item => item.id);
            const expandRows = this.tableData.filter(item => {
              return item.isClassifyRow && ids.includes(item.id);
            })
            this.$refs.yearTable.setTreeExpand(expandRows, true).then(() => {
              this.$refs.yearTable.scrollTo(tableScroll.scrollLeft, tableScroll.scrollTop);
            });
          });
        }
      }).catch(() => {
        this.status = null;
      });
    },
    mergeMethod({row}) {
      if (row.isClassifyRow) {
        return {rowspan: 1, colspan: this.tableColumnLength}
      } else{
        return {rowspan: 1, colspan: 1}
      }
    },
    setMerge() {
      this.mergeCells = [];
      this.tableData.forEach((item) => {
        if (item.isClassifyRow) {
          this.mergeCells.push({row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength});
        }
      })
    },
    collapse(el, column) {
      this.isCollapse = !this.isCollapse;
      if (this.isCollapse) {
        column.forEach(val => {
          if (val.title == "操作" || val.title == "提交状态") {
            val.visible = false;
          }
        });
        el && el.refreshColumn();
        this.setPosition("reset");
      } else {
        column.filter(val => val.title == "操作" || val.title == "提交状态").forEach(val => {
          val.visible = true;
        });
        el && el.refreshColumn();
        setTimeout(() => {
          this.setPosition();
        }, 50)
      }
    },
    setPosition(reset) {
      this.showCollapse = true;
      if (!document.getElementsByClassName('vxe-table--fixed-right-wrapper')[0]) {
        this.showCollapse = false;
        return false;
      }
      if (!reset && document.getElementsByClassName('vxe-table--fixed-right-wrapper')[0].offsetWidth === 0) {
        this.showCollapse = false;
        return false;
      }
      if (reset) {
        document.getElementsByClassName("collapse")[0].style.right = 0;       
      } else {
        try {
          const left = document.getElementsByClassName("vxe-table--fixed-right-wrapper")[0].offsetWidth;
          const height = document.getElementsByClassName('table-content')[0].offsetHeight;
          document.getElementsByClassName("collapse")[0].style.top = (height / 2 - 15)  + "px";
          document.getElementsByClassName("collapse")[0].style.right = left + "px";
        } catch(e) {
          throw e;
        }
      }
    },
    changeModel(e, submit) {
      const arr = this.tableColumn.filter(val => val.property !== undefined);
      let list = [];
      switch (e) {
        case "1":
          list = [];
          if(localStorage.getItem("year_table_herder") && !submit){
            let cache = JSON.parse(localStorage.getItem("year_table_herder"));
            this.tableColumn.forEach(v => {
              cache.forEach(t => {
                if (v.title == t.title){
                  v.visible = t.visible;
                }
              })
            });
          }else {
            this.tableColumn.forEach(val => {
              val.visible = true;
            });
          }
          this.isCollapse = false;
          setTimeout(() => {
            this.setPosition();
            // this.observerClass();
          }, 50);
          break;
        case "2":
          list = ["tree", "workItemCategory", "workItemContent","fullTarget", "weight" ,"startDate","finishDate","firstHalfTarget", "finishFullTarget","status", "operation"];
          this.isCollapse = false;
          setTimeout(() => {
            this.setPosition();
            // this.observerClass();
          },50);
          break;
        case "3":
          list = ["tree", "workItemCategory", "workItemContent", "fullTarget", "startDate","finishDate","firstHalfTarget", "firstHalfSummary", "status", "operation"];
          this.isCollapse = false;
          setTimeout(() => {
            this.setPosition();
            // this.observerClass();
          },50);
          break;
        case "4":
          list = ["tree", "workItemCategory", "workItemContent", "fullTarget", "startDate","finishDate", "finishFullTarget", "fullSummary", "status", "operation"];
          this.isCollapse = false;
          setTimeout(() => {
            this.setPosition();
            // this.observerClass();
          },50);
          break;
        case "5":
          list = ["tree", "workItemContent", "firstHalfTarget", "firstHalfSummary","finishFullTarget","fullSummary"];
          this.isCollapse = false;
          this.showCollapse = false;
          break;
      }
      if (list.length) {
        arr.forEach(val => {
          if (list.indexOf(val.property) !== -1){
            val.visible = true;
          }else {
            val.visible = false;
          }
        });
      }
      this.$refs.yearTable.refreshColumn();
    },
    emptyChildrenExpandHandler(row) {
      row.emptyChildrenExpand = !row.emptyChildrenExpand;
    },
    handleCommand(command) {
      this.selecterData = this.$refs.yearTable.getCheckboxRecords().filter(val => val.workId !== undefined && !val.isClassifyRow);
      if (this.selecterData.length == 0) {
        this.$message.error('请先选择数据');
        return false;
      }
      this.dialogContent = {
        title: '批量操作',
        componentName: 'batchEdit',
        width: '450px',
        command: command
      };
      this.editData.workId = this.workId;
      this.$refs.addSyncDialog.show();
    },
    setRowClass({row}) {
      if (row.isClassifyRow) {
        return 'classify-row';
      }
    },
    selectSingle(row) {
      this.$refs.yearTable.toggleCheckboxRow(row);
    },
    checkboxVisible({row}) {
      // 已提交、分类的行不可勾选
      return this.status !== 10 && !row.isClassifyRow;
    },
    
    activeRow({row}) {
      if (row.isClassifyRow) return false;
      this.row = row;
      let editRowOriginData = _.cloneDeep(row);
      delete editRowOriginData._X_ID;
      this.editRowOriginData = editRowOriginData;
    },
    editClosed({row}) {
      const editCurrRow = _.cloneDeep(row);
      delete editCurrRow._X_ID;
      if (_.isEqual(editCurrRow, this.editRowOriginData)) {
        return false;
      }
      if (this.buttonSave) {
        return false;
      }
      if (!row.isClassifyRow) {
        this.$confirm('确定要修改吗', '修改', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }).then(() => {
          this.saveService(row, editCurrRow);
        })
        .catch(() => {
          if (row.id) {
            this.writeRow(row, this.editRowOriginData);
            // _.merge(row, this.editRowOriginData);

            // this.setMerge();
          } else {
            this.deleteData(row, 0);
          }
        });
      }
    },
    async saveService(row, editCurrRow) {
      this.pending = true,
      editCurrRow.status = editCurrRow.status === null ? 0 : editCurrRow.status;
      await this.$ajax.post(this.$api.workManage.year.updateDetail, [editCurrRow], {noLoading: true}).then((res) => {
        const item = res.data instanceof Array ? res.data[0] : {};
        this.writeRow(row, item);
        // _.merge(row, item);
        this.pending = false;
        this.saveStatus ="已保存";
        
        this.timeoutSave && clearTimeout(timeoutSave);
        const timeoutSave = setTimeout(() => {
          this.saveStatus = "";
        }, 1000, this);
        this.$nextTick(() => {
          // this.setMerge();
        });
      }).finally(()=>{
        this.pending = false;
      });
        
    },
    writeRow(row, originRow) {
      for (const key in originRow) {
        if (Object.prototype.hasOwnProperty.call(originRow, key)) {
          row[key] = originRow[key];
        }
      }
    },
    querySearchWeight(_queryString, cb) {
      let weightList = [
        {"value": 5},
        {"value": 10},
        {"value": 15},
        {"value": 20},
        {"value": 25},
        {"value": 30}
      ];
      // 调用 callback 返回建议列表的数据
      cb(weightList);
    },
    async save(row) {
      this.pending = true;
      const paramRow = _.cloneDeep(row);
      paramRow.status = paramRow.status === null ? 0: paramRow.status;
      await this.$ajax.post(this.$api.year.yearWorkDetail.adu,  [paramRow], {noLoading: true}).then((res) => {
        const item = res.data instanceof Array? res.data[0]: {};
        item.expandRowContentFlag = row.expandRowContentFlag;
        // row.id = item.id;
        _.merge(row, item);
        // this.tableData.splice(index, 1, item);
        // this.$refs.yearTable.updateData(this.tableData);
        this.saveStatus = "已保存";
        this.timeoutSave && clearTimeout(timeoutSave);
        const timeoutSave = setTimeout(() => {
          this.saveStatus = "";
        }, 1000, this);
        this.$nextTick(() => {
          // this.setMerge();
        });
      }).finally(()=>{
        this.pending = false;
      });
    },
    
    expandThisRow(row) {
      row.emptyChildrenExpand = !row.emptyChildrenExpand;
      this.$refs.yearTable.toggleTreeExpand(row);
    },
    expandAll() {
      this.$refs.yearTable.setAllTreeExpand(true);
    },
    expandRowContent({row, column}) {
      if (column.type === 'checkbox' || column.title === 'NO.') {
        return false;
      }
      if (row.status === 0 || row.status === 30 || (row.status === 10 && this.editStatus === "approve")) {
        if(this.$getRowExpandFlag()) row.expandRowContentFlag = !row.expandRowContentFlag;
        this.$refs.yearTable.updateData(this.tableData);
      } else {
        if(this.$getRowExpandFlag()) row.expandRowContentFlag = !row.expandRowContentFlag;
        this.$refs.yearTable.updateData(this.tableData);
      }
      // this.$refs.yearTable.setTreeExpand(rows, checked)
    },
    moveClassify(row) {
      this.showHandle = true;
      this.nowClassify = row;
      this.classify = row.workClassify;
    },
    confirmClassify() {
      this.$confirm('确定要切换工作项分类吗', '切换分类', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        closeOnClickModal: false,
        closeOnPressEscape: false,
      }).then(() => {
        this.showHandle = false;
        this.nowClassify.workClassify = this.classify;
        this.$ajax.post(this.$api.workManage.year.updateDetail, [this.nowClassify]).then(() => {
          this.getList();
          this.$message.success('更改工作分类成功');
        });
      }).catch(() => {
        this.showHandle = false;
      });
    },
    copyLast() {
      this.expandAll();
      this.getList();
    },
    deleteData(row, alert) {
      this.$confirm('确定要删除吗', '删除', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        closeOnClickModal: false,
        closeOnPressEscape: false,
      }).then(() => {
        if (row.id) {
          this.$ajax.post(this.$api.workManage.year.delete, [row.id]).then(() => {
            this.row = {};
            const currentParentRow = this.tableData.find(item => item.workClassify === row.workClassify);
            _.remove(currentParentRow.children || [], t => t.id == row.id);
            this.tableData.splice(0, 0)
            if (alert) this.$message.success('删除成功');
          });
        } else {
          const currentParentRow = this.tableData.find(item => item.workClassify === row.workClassify);
          _.remove(currentParentRow.children || [], t => t.id == row.id);
          currentParentRow.children.splice(0, 0);
          if (alert) this.$message.success('删除成功');
        }
      })
    },
    // 列隐藏展示切换
    columnHideToggle(d) {
      let val = this.tableColumn.find(row => row.id == d.id)
      if (val) {
        val.visible = !val.visible
        this.$refs.yearTable && this.$refs.yearTable.refreshColumn();
        if (this.editStatus === "edit" && this.model == "1") {
          localStorage.setItem("year_table_herder", JSON.stringify(this.tableColumn));
        }
        setTimeout(() => {
          this.setPosition(null);
        }, 50);
      }
    },
  },
  created() {
    this.workId = this.$route.query.id || '';
    this.status = parseInt(this.$route.query.status) || 0;
    this.editStatus = this.$route.query.editStatus || '';
    this.newRow.workId = this.workId;
    this.msgId = this.$route.query.msgId || null;
    this.childIds = this.$route.query.childIds ? this.$route.query.childIds.split(',') : null;
    this.fromPage = this.$route.query.fromPage || '';
    this.getCategory();
    this.getWorkItemStatus().then(() => {
      this.workId && this.getList(1);
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.tableColumn = this.$refs.yearTable.getColumns();
      if(localStorage.getItem("year_table_herder") && this.editStatus === "edit" && this.model == "1"){
        let cache = JSON.parse(localStorage.getItem("year_table_herder"));
        this.tableColumn.forEach(v => {
          cache.forEach(t => {
            if (v.title == t.title) {
              v.visible = t.visible;
            }
          })
        })
        this.$refs.yearTable && this.$refs.yearTable.refreshColumn();
      } else {
        if(this.editStatus === "edit") {
          localStorage.setItem("year_table_herder", JSON.stringify(this.tableColumn));
        }
      }
    });
  },
}
</script>
<style lang="scss" scoped>
  .year-next {
    height: 100%;
    .header {
      .year-title {
        border-right: 1px solid #eaeef4;
        padding: 0 10px;
        .title-text {
          color: $--color-text-primary;
          font-size: 18px;
          font-weight: bold;
          display: inline-block;
        }
        .save-status {
          margin-left: 10px;
          font-size: 15px;
          color: #8e9694;
        }
      }
    }
    .container {
      margin-top: 15px;
      padding: 0 20px 20px;
      flex: 1;
      .el-icon-arrow-down {
        font-size: 12px;
      }
      .open {
        position: absolute;
        right: 0;
        top: 24px;
        text-align: right;
        font-size: 14px;
        color: #859291;
        cursor: pointer;
      }
      .table-content {
        position: relative;
        .collapse {
          position: absolute;
          cursor: pointer;
          width: 15px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          background-color: rgba(#000, 0.1);
          z-index: 99;
          &:hover {
            background-color: rgba(#000, 0.2);
          }
          i {
            font-size: 14px;
            color: #fff;
          }
        }
      }
      .search {
        position: relative;
        padding-top: 12px;
        padding-right: 56px;
        overflow: auto;
        .function {
          flex-wrap: wrap;
          align-items: center;
        }
        .atb-input {
          display: flex;
          .flex-form-item {
            margin-bottom: 12px;
            display: flex;
            flex: 1;
          }
          .read-mode {
            align-self: flex-end;
          }
          ::v-deep.el-form-item__label {
            white-space: nowrap;
          }
          ::v-deep.el-form-item__content {
            flex: 1;
            line-height: 1;
            .el-select, .el-autocomplete {
              width: 100%;
            }
          }
        }
      }
      ::v-deep .header-table {
        overflow: auto;
        flex-grow: 1;
        user-select: text;
        .vxe-table--header-wrapper {
          background-color: $--bg-color-complete !important;
        }
      }
      ::v-deep .classify-row {
        padding-left: 8px;
        background-color: $--color-bg-table-header;
        .vxe-cell--placeholder {
          font-size: 0;
        }
        .vxe-cell--checkbox, .vxe-cell {
          padding: 0;
        }
        .vxe-body--column {
          background-image: linear-gradient(#fff, #fff), linear-gradient(#fff, #fff)
        }
      }
      .vxe-tree-cell {
        padding: 0;
      }
      ::v-deep .vxe-tree--node-btn {
        color: $--color-primary;
      }
      ::v-deep .vxe-tree--btn-wrapper {
        left: 8px;
        top: 42%;
      }
      .row-add {
        height: 46px;
        color: $--color-primary;
        font-size: 14px;
        .classify-wrap {
          margin-left: 10px;
          cursor: pointer;
          .classify-name {
            position: relative;
            margin-right: 15px;
          }
        }
        .empty-children-expand-icon {
          position: absolute;
          left: -23px;
          top: -1px;
        }
        .classify-name {
          user-select: none;
          cursor: pointer;
        }
        .add-btn {
          margin-right: 15px;
          user-select: none;
          cursor: pointer;
        }
      }
    }
    ::v-deep .el-tag {
      padding: 0 10px;
      width: auto;
      text-align: center;
    }
    ::v-deep .vxe-cell {
      padding: 0 5px;
    }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
    ::v-deep .el-input-group__append {
      padding: 0 5px;
    }
    .el-button--import {
      border-color: #def6e8;
      color: #0dcc82;
    }
    ::v-deep .el-button--downloadTemplate {
      width: 100px !important;
      background-color: #def6e8;
      border-color: #def6e8;
      color: #0dcc82;
    }
    ::v-deep .el-radio-button {
      margin-right: 20px;
      margin-bottom: 15px;
      .el-radio-button__inner {
        border-radius: 20px;
        padding: 0 20px;
        width: 100%;
        line-height: 36px;
        border: 1px solid $--color-primary;
        color: $--color-primary;
      }
    }
    ::v-deep .el-radio-button.is-active .el-radio-button__inner {
      color: $--color-white;
    }
  }
</style>



